<ngx-ui-loader
  [fgsColor]="loaderConfig.fgsColor"
  [fgsSize]="loaderConfig.fgsSize"
  [bgsColor]="loaderConfig.bgsColor"
  [bgsOpacity]="loaderConfig.bgsOpacity"
  [bgsSize]="loaderConfig.bgsSize"
  [gap]="loaderConfig.gap"
  [logoSize]="loaderConfig.logoSize"
  [overlayColor]="loaderConfig.overlayColor"
  [pbColor]="loaderConfig.pbColor"
  [pbThickness]="loaderConfig.pbThickness"
  [hasProgressBar]="loaderConfig.hasProgressBar"
  [text]="loaderConfig.text"
  [textColor]="loaderConfig.textColor"
  ></ngx-ui-loader>
<router-outlet></router-outlet>
